import React from 'react'
import { connect } from 'react-redux'
import SelectWithOptionalTextField from '../../../components/SelectWithOptionalTextField'
import FormInput from '../../../components/FormInput'
import { Row, Col, Form } from 'react-bootstrap'
import {
  handleDemographicChartFieldChange,
  submitChartDemographicsInfo,
 } from '../reducers/patientDemographicsFormReducer'

import { userRegionIsUS } from '../../../functions/userPermissions'


const PatientDemographicForm = (props) => {

  const handleChange = (e) => {
    const { name, value } = e.target
    return props.handleDemographicChartFieldChange(name, value)
  }

  const handlePlaceOfResidenceChange = (e) => {
    const { name, value } = e.target
    props.handleDemographicChartFieldChange(name, value)
    if (name === 'placeOfResidence' && value?.toLowerCase() !== 'other') {
      props.handleDemographicChartFieldChange('placeOfResidenceOther', '')
    }
  }

  // const handleSelect = (e) => {
  //   const { name, value, checked } = e.target
  //   if (checked) {
  //     return props.handleDemographicChartFieldChange(name, value)
  //   } else {
  //     return props.handleDemographicChartFieldChange(name, '')
  //   }
  // }

  const handleBlur = () => {
    props.submitChartDemographicsInfo(props)
  }

  const {
    age,
    gender,
    race,
    // countryOfBirth,
    placeOfResidence,
    chartForReview,
    currentUser,
  } = props


  // const placeOfResidenceInfoText = (
  //   <div>
  //     <p><strong>Private Residence:</strong> Home</p>
  //     <p><strong>Hospice:</strong> Place to receive near the end of life care for patients with terminal diseases</p>
  //   </div>
  // )

  const placeOfResidenceCheckboxOptions = [
    {value: 'Private Residence (home)',
    fieldName: 'privateResidence'},
    {value: 'Healthcare facility such as Nursing home/skilled nursing facilities Rehabilitation facility, Long term acute care hospital (LTACH)',
    fieldName: 'ltach'},
    {value: 'Assisted living, Residential care/Group home',
    fieldName: 'assistedLiving'},
    {value: 'Hospice (place to receive near the end of life care for patients with terminal diseases)',
    fieldName: 'hospice'},
    {value: 'Other Institutions such as: Military facility, Jail/Prison, etc.',
    fieldName: 'otherInstitutions'},
    {value: 'Other',
    fieldName: 'other',
    textFields: [{
      displayName: 'Please Specify',
      fieldName: 'placeOfResidenceOther'
    }]},
  ]

  const genderCheckboxOptions = [
    {value: 'Male',
    fieldName: 'male'},
    {value: 'Female',
    fieldName: 'female'},
    {value: 'Other/Not Recorded',
    fieldName: 'other'}
  ]

  const raceCheckboxOptions = [
    {value: 'White',
    fieldName: 'white'},
    {value: 'Black',
    fieldName: 'black'},
    {value: 'Hispanic',
    fieldName: 'hispanic'},
    {value: 'Asian',
    fieldName: 'asian'},
    {value: 'Other',
    fieldName: 'other'},
  ]

  return (
    <div id="PatientDemographicForm">
      <Form validated={props.chartIsIncompleteModalData.length !== 0 ? true: false}>
        <FormInput
          label={'Age'}
          name={'age'}
          value={age}
          type={'number'}
          placeholder={'Enter the patient\'s age (in years) at the time of admission'}
          xs={12}
          sm={12}
          md={8}
          lg={6}
          onChange={handleChange}
          onBlur={handleBlur}
          disabled={chartForReview}
          required={true}
        />

        <SelectWithOptionalTextField
          label={'Gender'}
          options={genderCheckboxOptions}
          handleChange={handleChange}
          selectFieldName={'gender'}
          selected={gender}
          onBlur={handleBlur}
          disabled={chartForReview}
          placeholder="Please make a selection"
          required={true}
          {...props}
        />

        {userRegionIsUS(currentUser) ?
          <Row>
            <Col>
              <Form.Group>
                <SelectWithOptionalTextField
                  label={'Race'}
                  options={raceCheckboxOptions}
                  handleChange={handleChange}
                  selectFieldName={'race'}
                  selected={race}
                  onBlur={handleBlur}
                  disabled={chartForReview}
                  placeholder="Please make a selection"
                  required={true}
                  {...props}
                />
              </Form.Group>
            </Col>
          </Row>
          :
          null
        }

        {/* <Form.Label>
          <strong>For patients in the EU: </strong>
        </Form.Label>
        <Row>
          <FormInput
            label={'Country of birth'}
            name={'countryOfBirth'}
            value={countryOfBirth}
            type={'text'}
            placeholder={'Enter country of birth'}
            xs={12}
            sm={12}
            md={8}
            lg={6}
            asCol
            onChange={handleChange}
            onBlur={handleBlur}
            disabled={chartForReview}
          />
          <Col id="inline-checkbox" xs={6} sm={6} md={4} lg={2}>
            <Form.Group>
              <Form.Check
                name={'countryOfBirth'}
                value={'n/a'}
                label={'N/A'}
                checked={countryOfBirth === 'n/a' ? true : false}
                onChange={handleSelect}
                onBlur={handleBlur}
                disabled={chartForReview}
              />
            </Form.Group>
          </Col>
        </Row> */}

        <SelectWithOptionalTextField
          label={'Place of patient’s residence before hospital admission'}
          // infoText={placeOfResidenceInfoText}
          options={placeOfResidenceCheckboxOptions}
          handleChange={handlePlaceOfResidenceChange}
          selectFieldName={'placeOfResidence'}
          selected={placeOfResidence}
          onBlur={handleBlur}
          disabled={chartForReview}
          placeholder="Please make a selection"
          required={true}
          {...props}
        />

      </Form>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    chartIsIncompleteModalData: state.chartFormReducer.chartIsIncompleteModalData,
    patientChartUrl: state.chartFormReducer.patientChartUrl,
    demographicsInfoUrl: state.patientDemographicsFormReducer.demographicsInfoUrl,
    age: state.patientDemographicsFormReducer.age,
    gender: state.patientDemographicsFormReducer.gender,
    race: state.patientDemographicsFormReducer.race,
    countryOfBirth: state.patientDemographicsFormReducer.countryOfBirth,
    placeOfResidence: state.patientDemographicsFormReducer.placeOfResidence,
    placeOfResidenceOther: state.patientDemographicsFormReducer.placeOfResidenceOther,
    currentUser: state.loginReducer.currentUser,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    handleDemographicChartFieldChange: (key, value) => {
       return dispatch(handleDemographicChartFieldChange(key, value))
    },

    submitChartDemographicsInfo: (props) => dispatch(submitChartDemographicsInfo(props)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PatientDemographicForm)
